const topics = [
    {
        name: "Coronary",
        topics: [
            "ACS/AMI",
            "Clinical Science and Decision Making",
            "Complex PCI",
            "Coronary Devices and Ancillary Tools",
            "Coronary Imaging & Physiology",
            "Non-Obstructive CAD (ANOCA/MINOCA, SCAD)",
        ],
    },
    {
        name: "Endovascular",
        topics: [
            "Arterial Disease",
            "Interventions For Hypertension",
            "Pulmonary Embolism/Venous Thromboembolic Disease",
        ],
    },
    {
        name: "Heart Failure",
        topics: ["Interventional Heart Failure"],
    },
    {
        name: "Innovation & FDA",
        topics: [
            "Innovation",
            "FDA Townhall",
            "Innovation & FDA Townhall Meeting",
            "TCTMedtech Innovation Forum: FDA University for Startups",
            "TCTMedtech Innovation Forum: Global Market Dynamics",
            "TCTMedtech Innovation Forum: Hot Topics in MedTech Innovation",
        ],
    },
    {
        name: "Structural",
        topics: [
            "Aortic Disease and Intervention",
            "Aortic Disease & Intervention",
            "LAAO Techniques and Technologies",
            "LAAO Techniques & Technologies",
            "Mitral Disease and Intervention",
            "Mitral Disease & Intervention",
            "Tricuspid Disease and Intervention",
            "Tricuspid Disease & Intervention",
            "Tricuspid",
            "Structural Imaging",
            "Structural Complications"
        ],
    },
]
export default topics
